"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FormFeedback;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FormFeedbackModule = _interopRequireDefault(require("./FormFeedback.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

FormFeedback.propTypes = {
  intent: _propTypes.default.oneOf(['danger', 'warning']),
  tag: _propTypes.default.string
};
FormFeedback.defaultProps = {
  tag: 'div'
};

function FormFeedback(_ref) {
  var children = _ref.children,
      intent = _ref.intent,
      Tag = _ref.tag;
  var classes = (0, _classnames.default)(_FormFeedbackModule.default.Feedback, _defineProperty({}, _FormFeedbackModule.default[intent], !!intent));
  return _react.default.createElement(Tag, {
    className: classes
  }, children);
}

//# sourceMappingURL=FormFeedback.js.map